import axiosClient from "../axiosClient";
import { Abonnement } from "../interfaces/abonnement.interface";
import { Assurance } from "../interfaces/assurance.interface";

export const findAllAttestations = async () => {
  const { data } = await axiosClient.get<{
    citeo: Abonnement[];
    assurances: Assurance[];
    sna: Abonnement[];
  }>("/users/attestations");
  return data;
};
